// Generated by scripts/extract-hackgrid-wheel-labels.mjs — do not edit by hand.
// Panel silhouettes lifted out of public/images/Home/Hackgrid_core.svg so the wheel
// can be hovered sector by sector. Coordinates are in the artwork viewBox.
// The matching red labels are emitted as public/images/Home/hackgrid-label-*.svg.

export const WHEEL_VIEW_BOX = "0 0 344 319";

/** Red copy of each sector label, laid over the white text baked into the artwork. */
export const WHEEL_LABEL_SRC: Record<string, string> = {
  topLeft: "/images/Home/hackgrid-label-topLeft.svg",
  topRight: "/images/Home/hackgrid-label-topRight.svg",
  bottomLeft: "/images/Home/hackgrid-label-bottomLeft.svg",
  bottomRight: "/images/Home/hackgrid-label-bottomRight.svg",
};

/** Panel silhouette per sector, used as the transparent hit area. */
export const WHEEL_PANEL_PATHS: Record<string, string> = {
  topLeft: "M149.1,14.9l-1,.6-45.4,26.2-45.2,26.1-1,.6v18.9l1,.6,45.3,26.4,45.3,26.2,1,.6,1-.6,14.4-8.3,1-.6v-53.6c.1,0,0-52.5,0-52.5v-1.2l-1-.6-14.4-8.2-1-.6h0Z",
  topRight: "M195.9,14.9l-1,.6-14.4,8.3-1,.6v53.6c-.1,0,0,52.5,0,52.5v1.2l1,.6,14.4,8.2,1,.6,1-.6,45.4-26.2,45.2-26.1,1-.6v-18.9l-1-.6-45.3-26.4-45.3-26.1-1-.6h0Z",
  bottomLeft: "M149.1,180.7l-1,.6-45.3,26.2-45.3,26.4-1,.6v18.9l1,.6,45.2,26.1,45.4,26.2,1,.6,1-.6,14.4-8.2,1-.6v-53.6c0,0,0-52.4,0-52.4v-1.1l-1-.6-14.4-8.3-1-.6Z",
  bottomRight: "M195.9,180.7l-1,.6-14.4,8.2-1,.6v53.6c0,0,0,52.4,0,52.4v1.2l1,.6,14.4,8.3,1,.6,1-.6,45.3-26.1,45.3-26.4,1-.6v-18.9l-1-.6-45.2-26.1-45.4-26.2-1-.6Z",
};
